import "./index.scss";

import Avatar from "@mui/material/Avatar";
import { ReactComponent as MemberIcon } from "assets/images/icons/member.svg";
import { formatName } from "helpers/utils";
import { AuthorizedUser } from "models/auth";
import { authActions } from "modules/auth";
import { memo, useMemo } from "react";
import { toast } from "react-toastify";
import { useAppDispatch } from "redux/hooks";

interface TopbarProps {
  userData?: AuthorizedUser;
  pageTitle?: string;
}

const Topbar = (props: TopbarProps) => {
  const { userData, pageTitle } = props;
  const dispatch = useAppDispatch();

  const userName = useMemo(() => {
    return userData ? formatName(userData.user.strFirstName, userData.user.strLastName) : "";
  }, [userData]);

  const facilityName = useMemo(() => {
    return userData ? userData.facility_name : "";
  }, [userData]);

  const successCallback = () => {
    window.location.reload();
  };

  const exitImpersonation = () => {
    try {
      dispatch(authActions.exitImpersonation({ successCallback }));
    } catch (_e) {
      toast(_e.message, { type: "error" });
    }
  };

  const handleLogout = () => {
    dispatch(authActions.logout());
  };

  return (
    <div className="topbar">
      <div className="topbar left">
        <h1>{pageTitle}</h1>
      </div>
      <div className="topbar right">
        <div className="topbar right-info">
          {userData?.isLoginOverride ? (
            <h2>
              {userName}{" "}
              <a href="#" onClick={exitImpersonation}>
                [logout]
              </a>
            </h2>
          ) : (
            <h2>
              {userName}{" "}
              <a href="#" onClick={handleLogout}>
                [logout]
              </a>
            </h2>
          )}
          <h3 className="h3 regular">{userData?.user.bytType === 3 ? `Admin` : `Instructor`}</h3>
          <h4>{facilityName}</h4>
        </div>
        {userData?.user.image ? (
          <Avatar alt="avatar" className="user-avatar" src={userData?.user.image} />
        ) : (
          <Avatar alt="avatar" className="user-avatar" sx={{ bgcolor: "#BB7FFF" }}>
            <MemberIcon width={30} height={30} stroke={"#fff"} />
          </Avatar>
        )}
      </div>
    </div>
  );
};

export default memo(Topbar);
